import { useEffect } from 'react';
import { Link, Outlet, isRouteErrorResponse, useRouteError } from 'react-router';
import { posthog, posthogEnabled } from '@/lib/posthog';

export function Root() {
  return <Outlet />;
}

export function RootErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    if (posthogEnabled && error instanceof Error) posthog.captureException(error);
  }, [error]);

  const isResponse = isRouteErrorResponse(error);
  const title = isResponse ? `${error.status} ${error.statusText}` : 'Something went wrong';
  const detail = isResponse
    ? typeof error.data === 'string'
      ? error.data
      : null
    : error instanceof Error
      ? error.message
      : null;

  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <div className="w-full max-w-md rounded-xl border bg-white p-8 shadow-sm">
        <h1 className="mb-2 text-2xl">{title}</h1>
        {detail && <p className="mb-4 text-sm text-muted-foreground break-words">{detail}</p>}
        <div className="flex gap-3 text-sm">
          <button onClick={() => window.location.reload()} className="ff-link">
            Reload
          </button>
          <Link to="/contacts" className="ff-link">
            Go to contacts
          </Link>
        </div>
      </div>
    </main>
  );
}
